import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { OpOperator } from "../../models/core"
import { Activity, Enums } from "../../models/common"

import { ConfigHelper, UserSession } from "../../helpers"

import { MenuItem } from "../common/sidebar-menu/common.sidebar-menu.directive"
import { default as SERVICES_MODULE_NAME } from './../../services/services.module'
import { SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { ConsumerTypeScope, ConsumerTypeController } from './consumer-types.controller'
import { ConsumerTypeCreateEditDirective } from './create-edit/consumer-types-create-edit.directive'
import { ConsumerTypeHelper } from './consumer-types.helper'
import { ConsumerTypeDetailsDirective } from './details/consumer-types-details.directive'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'
import { StateService, StateProvider } from '@uirouter/angularjs'

//#region Asset Imports

import * as TEMPLATE from './consumer-types.tpl.html'

//#endregion

// #region Consts

const CONTROLLER_NAME: string = 'ConsumerTypeController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'consumerTypeCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'consumerTypeDetails'
const MODULE_NAME: string = 'simax.consumers-types'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'CONSUMER_TYPE_NAME'
const STATE_NAME: string = 'consumersTypes'
const STATE_URL: string = '/consumersTypes'

// #endregion


// #region Setup

const module = angular.module(MODULE_NAME, [apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [$SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'api', 'localDictionary', USER_SESSION_SERVICE_NAME, SYSTEM_SERVICE_NAME, (
    $scope: ConsumerTypeScope,
    $state: StateService,
    $timeout: ng.ITimeoutService,
    api: Api,
    localDictionary: LocalDictionaryFactory,
    userSession: UserSessionService,
    systemService: SystemService
) => new ConsumerTypeController(
    $scope,
    $state,
    $timeout,
    api,
    localDictionary,
    userSession,
    systemService,
    ConsumerTypeHelper.REFERENCE_TYPE,
    ConsumerTypeHelper.SIMAX_MODULE_NAME
)])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new ConsumerTypeDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new ConsumerTypeCreateEditDirective()])

module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Consumer_Type_IdConsumerType',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.CONSUMER_TYPE_LIST)
                && !loggedOperator.hasPermission(Activity.CONSUMER_TYPE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ConsumerTypeModuleMainGrid)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.LOCATION_TYPE),
                    'consumersTypes',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    1
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// #endregion


export default MODULE_NAME